export default __webpack_public_path__ + "6ce1690aad41c66d09559df092c876c3.png";